export default __webpack_public_path__ + "static/media/Audio-Number-3.ed91e234.mp3";